import type { IExternalUser } from "@/interfaces/user";
import { appSelector } from "@/redux/selectors/app.selector";
import { userSelector } from "@/redux/selectors/user.selector";
import { useSelector } from "@/redux/store";

export const useUser = () => {
  const currentUser = useSelector(appSelector.user);
  const users: IExternalUser[] = useSelector(userSelector.users)!;

  const findById = (lassoId: string) => {
    return users.find((user) => user.lassoUserId === lassoId);
  };

  return { currentUser, users, findById };
};
